module.exports = __webpack_public_path__ + "img/white-circle.04dfd56.svg";